import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetMovesMissingRefPoolsQueryVariables = Types.Exact<{
  start: Types.Scalars['timestamptz']['input'];
  end: Types.Scalars['timestamptz']['input'];
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetMovesMissingRefPoolsQuery = { __typename?: 'query_root', moves: Array<{ __typename?: 'moves', id: number, createdBy?: string | null }> };


export const GetMovesMissingRefPoolsDocument = gql`
    query getMovesMissingRefPools($start: timestamptz!, $end: timestamptz!, $customerId: bigint!) {
  moves(
    where: {active: {_eq: 1}, move_type: {_eq: "drive"}, consumer_pickup: {_eq: true}, reference_num: {_is_null: true}, _and: [{_or: [{customer_id: {_eq: $customerId}}, {payer_id: {_eq: $customerId}}]}, {_or: [{pickup_time: {_gte: $start, _lte: $end}}, {ready_by: {_gte: $start, _lte: $end}}]}]}
    order_by: {createdBy: desc}
  ) {
    id
    createdBy
  }
}
    `;

/**
 * __useGetMovesMissingRefPoolsQuery__
 *
 * To run a query within a React component, call `useGetMovesMissingRefPoolsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMovesMissingRefPoolsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMovesMissingRefPoolsQuery({
 *   variables: {
 *      start: // value for 'start'
 *      end: // value for 'end'
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetMovesMissingRefPoolsQuery(baseOptions: Apollo.QueryHookOptions<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables> & ({ variables: GetMovesMissingRefPoolsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>(GetMovesMissingRefPoolsDocument, options);
      }
export function useGetMovesMissingRefPoolsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>(GetMovesMissingRefPoolsDocument, options);
        }
// @ts-ignore
export function useGetMovesMissingRefPoolsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>;
export function useGetMovesMissingRefPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMovesMissingRefPoolsQuery | undefined, GetMovesMissingRefPoolsQueryVariables>;
export function useGetMovesMissingRefPoolsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>(GetMovesMissingRefPoolsDocument, options);
        }
export type GetMovesMissingRefPoolsQueryHookResult = ReturnType<typeof useGetMovesMissingRefPoolsQuery>;
export type GetMovesMissingRefPoolsLazyQueryHookResult = ReturnType<typeof useGetMovesMissingRefPoolsLazyQuery>;
export type GetMovesMissingRefPoolsSuspenseQueryHookResult = ReturnType<typeof useGetMovesMissingRefPoolsSuspenseQuery>;
export type GetMovesMissingRefPoolsQueryResult = Apollo.QueryResult<GetMovesMissingRefPoolsQuery, GetMovesMissingRefPoolsQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/missingRefReport/queries/getMovesMissingRefPools.query.gql}
 */
export async function getMovesMissingRefPools(
  variables: GetMovesMissingRefPoolsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetMovesMissingRefPoolsQuery['moves']>
export async function getMovesMissingRefPools(
  variables: GetMovesMissingRefPoolsQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetMovesMissingRefPoolsQuery>
export async function getMovesMissingRefPools(
  variables: GetMovesMissingRefPoolsQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetMovesMissingRefPoolsQuery['moves'] | GetMovesMissingRefPoolsQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetMovesMissingRefPoolsQuery>(
    GetMovesMissingRefPoolsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.moves
}